import { defer } from 'react-router-dom';

import { QueryClient } from '@tanstack/react-query';

import { isNotDefined, isTokenExpired, retrieveToken } from '@hsp/utilities';

import { createDataPointsQuery } from '@p/ab/shared/hooks/queries/categories/fetch-data-points.hook';

import { defaultDataPoints } from '@t/api/audience/defaults/data-point.default';

const query = createDataPointsQuery();

export const categoryLoader = (queryClient: QueryClient) => {
  return async () => {
    const { queryKey } = query;

    if (isNotDefined(queryKey)) {
      throw new Error('QueryKey not provided');
    }

    const token = retrieveToken();

    if (isNotDefined(token) || isTokenExpired(token)) {
      return defer({ categories: defaultDataPoints });
    }

    const categories = queryClient.ensureQueryData({ ...query, queryKey });

    return defer({ categories });
  };
};
